<template>
  <a-layout-content id="services" class="all-c services-container">
    <div class="en" v-show="isEnglish">
      <h2 class="services-title">{{ $t('servicesWeOffer') }}</h2>
      <div class="service-box">
        <div class="s-box-left">
          <div class="mobile-img">
            <img src="../../public/4-1.png" alt="services-left-img" />
          </div>
          <div class="content">
            <h3 class="service-heading">{{ $t('inSchoolOccupationalTherapyServices') }}</h3>
            <ul class="service-list">
              <li><span>{{ $t('occupationalTherapyServices') }}</span></li>
              <li><span>{{ $t('teacherInterviews') }}</span></li>
              <li><span>{{ $t('classroomObservations') }}</span></li>
              <li><span>{{ $t('screeningsAndAssessments') }}</span></li>
              <li><span>{{ $t('teacherTraining') }}</span></li>
              <li><span>{{ $t('ongoingSupportInSchool') }}</span></li>
            </ul>
          </div>
          <div class="bg">
            <img src="../../public/4-1.png" alt="services-left-img" />
            <img src="../../public/4-0.png" alt="services-left-bg" />
          </div>
        </div>
        <div class="s-box-right">
          <div class="mobile-img">
            <img src="../../public/4-2.png" alt="services-left-img" />
          </div>
          <div class="content">
            <h3 class="service-heading">{{ $t('onSiteInPersonOccupationalTherapyServices') }}</h3>
            <ul class="service-list">
              <li><span>{{ $t('occupationalTherapyServices2') }}</span></li>
              <li><span>{{ $t('parentInterviews') }}</span></li>
              <li><span>{{ $t('comprehensiveAssessment') }}</span></li>
              <li><span>{{ $t('parentAdvocacyAndTraining') }}</span></li>
              <li><span>{{ $t('supportAtHome') }}</span></li>
            </ul>
          </div>
          <div class="bg">
            <img src="../../public/4-2.png" alt="services-right-img" />
            <img src="../../public/4-3.png" alt="services-right-bg" />
          </div>
        </div>
      </div>
      <div class="additional-services">
        <img src="../../public/fly.svg" alt="services-fly" />
        <span class="add-services-heading">{{ $t('additionalServices') }}</span>
        <p>{{ $t('academicLearningSupportAndClassroomPerformanceSupport') }}</p>
      </div>
    </div>
    <div class="cn" v-show="!isEnglish">
      <h2 class="services-title">{{ $t('servicesWeOffer') }}</h2>
      <div class="service-box">
        <div class="s-box-left">
          <div class="mobile-img">
            <img src="../../public/4-1.png" alt="services-left-img" />
          </div>
          <div class="content">
            <h3 class="service-heading">{{ $t('inSchoolOccupationalTherapyServices') }}</h3>
            <ul class="service-list">
              <li><span>{{ $t('occupationalTherapyServices') }}</span></li>
              <li><span>{{ $t('teacherInterviews') }}</span></li>
              <li><span>{{ $t('classroomObservations') }}</span></li>
              <li><span>{{ $t('screeningsAndAssessments') }}</span></li>
              <li><span>{{ $t('teacherTraining') }}</span></li>
              <li><span>{{ $t('ongoingSupportInSchool') }}</span></li>
            </ul>
          </div>
          <div class="bg">
            <img src="../../public/4-1.png" alt="services-left-img" />
            <img src="../../public/4-0.png" alt="services-left-bg" />
          </div>
        </div>
        <div class="s-box-right">
          <div class="mobile-img">
            <img src="../../public/4-2.png" alt="services-left-img" />
          </div>
          <div class="content">
            <h3 class="service-heading">{{ $t('onSiteInPersonOccupationalTherapyServices') }}</h3>
            <ul class="service-list">
              <li><span>{{ $t('occupationalTherapyServices') }}</span></li>
              <li><span>{{ $t('parentInterviews') }}</span></li>
              <li><span>{{ $t('comprehensiveAssessment') }}</span></li>
              <li><span>{{ $t('parentAdvocacyAndTraining') }}</span></li>
              <li><span>{{ $t('supportAtHome') }}</span></li>
            </ul>
          </div>
          <div class="bg">
            <img src="../../public/4-2.png" alt="services-right-img" />
            <img src="../../public/4-3.png" alt="services-right-bg" />
          </div>
        </div>
      </div>
      <div class="additional-services">
        <img src="../../public/fly.svg" alt="services-fly" />
        <span class="add-services-heading">{{ $t('additionalServices') }}</span>
        <p>{{ $t('academicLearningSupportAndClassroomPerformanceSupport') }}</p>
      </div>
    </div>
  </a-layout-content>
</template>

<script>
export default {
  data() {
    return {
      isEnglish: true
    };
  },
  computed: {
    currentLang() {
      return this.$i18n.locale;
    }
  },
  watch: {
    currentLang(newLang) {
      this.isEnglish = newLang === 'en';
    }
  }
};
</script>

<style scoped lang="less">
@mainBg: #f8f5f0;
@mainBg2: #f8f5f1;
@mainColor1: #de94a4;
@mainColor2: #eebac0;
@mainColor3: #A98578;
@mainColor4: #F6DEC7;
@mainColor5: #F8F5F1;
@mainFont: "MontserratMedium", sans-serif;
@mainFontSub: "MontserratLight", sans-serif;
.services-container {
  position: relative;
  box-sizing: border-box;
  height: calc(100vh - 110px);
  
  .services-title {
    position: absolute;
    top: 3vw;
    margin-left: 50%;
    transform: translateX(-50%);
    font-size: 2.5vw;
    font-weight: 600;
    color: @mainColor3;
    font-family: @mainFont;
  }
  .service-box {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    gap: 4vw;
    > div {
      width: 33.5vw;
      position: relative;
      .mobile-img {
        display: none;
      }
      .content {
        position: absolute;
        width: 83%;
        height: 30%;
        bottom: 2.5%;
        left: 50%;
        transform: translateX(-50%);
        z-index: 2;
        line-height: 1.1;
        .service-heading {
          font-size: 1.2vw;
          font-weight: bold;
          color: @mainColor3;
          font-family: @mainFont;
        }
      
        .service-list {
          list-style-type: none;
          padding-left: 0;
        }
      
        .service-list li {
          font-size: 1.1vw;
          padding-left: 0.8vw;
          color: #000;
          word-wrap: break-word;
          overflow-wrap: break-word;
          position: relative;
          line-height: 1.4;
          font-family: @mainFontSub;
          &::before {
            position: absolute;
            content: '';
            top: 0.75vw;
            width: 0.2vw;
            height: 0.2vw;
            border-radius: 1vw;
            margin-left: -0.8vw;
            background: #000;
          }
        }
      }
      .bg {
        > img {
          display: inline-block;
          width: 100%;
          position: relative;
          &:first-child {
            position: absolute;
            top: 31.3%;
            left: 50%;
            transform: translateX(-50%);
            width: 65%;
            z-index: 2;
            &[alt="services-right-img"] {
              height: 34%;
              width: auto;
            }
          }
        }
      }
    }
  }

  .cn {
    .service-box {
      >div {
        >.content {
          width: 70%;
          bottom: 0;
        }
      }
    }
  }

  .additional-services {
    width: 74vw;
    padding: 0.5vw 1.2vw;
    margin: 1vw auto;
    background: @mainBg;
    border-radius: 0.8vw;
    display: flex;
    align-items: center;
    gap: 1vw;
    img {
      width: 3vw;
    }
    .add-services-heading {
      font-size: 1.2vw;
      font-weight: bold;
      color: @mainColor3;
      display: inline;
      font-family: @mainFont;
    }
    p {
      flex: 1;
      color: #000;
      font-size: 1.1vw;
      border: 1px solid pink;
      border-radius: 0.9vw;
      padding: 0.5vw 1.5vw;
      margin-bottom: 0;
      font-family: @mainFontSub;
    }
  }
  @media screen and (max-width: 768px) {
    .services-title {
      position: static;
      font-size: 4vw;
      text-align: center;
      margin: 0;
      transform: none;
      margin-bottom: 3vw;
    }
    .service-box {
      flex-direction: column;
      > div {
        width: 85%;
        margin: 0 auto;
        transform: none;
        background: @mainColor5; 
        border-radius: 12vw;
        padding:  5vw 0 3vw;
        box-sizing: border-box;
        .mobile-img {
          display: block;
          box-sizing: border-box;
          width: 85%;
          height: 45vw;
          margin: 0 auto;
          background: @mainColor2;
          padding: 5vw;
          border-radius: 12vw;
          text-align: center;
          > img {
            &:last-child {
              height: 100%;
              width: auto;
              margin: 0 auto;
            }
          }
        }
        &.s-box-right {
          .mobile-img {
            background: @mainColor4;
          }
        }
        .bg {
          display: none;
        }
        .content {
          position: static;
          transform: none;
          height: auto;
          width: 100%;
          margin-top: 5vw;
          padding: 0 8vw;
          .service-heading {
            font-size: 3.3vw;
          }
          .service-list li {
            font-size: 3.3vw; 
            font-family: @mainFont;
            &::before {
              top: 1.5vw;
              width: 0.6vw;
              height: 0.6vw;
              border-radius: 1vw;
              margin-left: 0;
            }
            span {
              margin-left: 2vw;
              display: block;
            }
          }
        }
      }
    }
    .additional-services {
      width: 85vw;
      flex-direction: column;
      padding: 5vw;
      margin-top: 5vw;
      border-radius: 3vw;
      > img {
        width: 10vw;
      }
      .add-services-heading {
        font-size: 3.3vw;
        margin-bottom: 2.5vw;
      }
      p {
        font-size: 3.3vw;
        font-family: @mainFont;
      }
    }
  }
}
</style>
